import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from "react-router-dom";

import CharacterSheetParent from '@dndComponents/character/CharacterSheetParent';
import DandDCharacterUtilities from '@dndUtilities/char_utilities';
import { DATA_TYPE_INFO } from '@dndModels/Constants';
import { Character } from '@dndModels';
import LoadingBox from '@components/input/LoadingBox';
import { useDataTypeLoadProgress } from "@utilities/useApiLoadStatus";
import { core_data_types } from "@dndUtilities/data_utilities_class";

const char_util = DandDCharacterUtilities.getInstance();

export default function CharacterDetails() {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [loading_message, setLoadingMessage] = useState("");
  const [percentage, setPercentage] = useState(0);
  // Loads that finished before this page opened don't count toward its loading bar.
  const [load_since] = useState(() => Date.now());
  // While the character's data is downloading, show the average across those loads
  // (both source book scopes) - after that, the connect steps report through onProgress.
  const load_progress = useDataTypeLoadProgress(core_data_types, load_since);
  const shown_percentage = load_progress !== undefined && load_progress < 1 ? load_progress * 100 : percentage;
  const [fetched, setFetched] = useState(false);
  const [char, setChar] = useState<Character>(new Character());

  // Loads the editing Character into state
  const loadObject = useCallback(async (char_id: string) => {
    // console.log("Loading");
    // debugger;
    const onProgress = (data_type: string, percent: number ) => {
      const dt_info = DATA_TYPE_INFO.find(o => o.data_type === data_type);
      // console.log(dt_info);
      // console.log(percentage);
      // debugger;
      if (dt_info) {
        setLoadingMessage(`Loading ${dt_info.plural}`);
      } else if (data_type === "Processing") {
        setLoadingMessage("Processing");
      } else {
        setLoadingMessage(`Loading ${data_type}`);
      }
      setPercentage(percent * 100);
    };
    const onError = (message: string) => {
      setLoadingMessage(message);
    };
    const res = await char_util.getCharacter({ id: char_id, onProgress, onError });
    // debugger;
    if (res) {
      setChar(res);
    }
    setLoading(false);
    return res;
  }, []);

  useEffect(() => {
    if (!fetched) {
      setFetched(true);
      if (id && id !== "") {
        setLoading(true);
        setTimeout(() => {
          loadObject(id);
        }, 100);
      }
    }
  }, [fetched, loadObject]);
  
  if (id) {
    if (!fetched || loading) {
      return (
        <div className="centered">
          <LoadingBox message={loading_message} percentage={shown_percentage} size={window.innerHeight * 0.5} height={window.innerHeight - 100} />
        </div>
      );
    }
    return (
      <CharacterSheetParent
        char={char}
      />
    );
  } else {
    return <>No Character ID</>
  }
}
